import isEmpty from 'lodash-es/isEmpty';
import isArray from 'lodash-es/isArray';
import {Object as ObjectHelper} from '@galilee/sdk-core';
import {Filters} from '@common/types/components/datatable.types';
import {FILTER_FACET} from '@common/constants/datatable/datatableConstants';
export const getAuthorizationJwtHeader = (jwt: string) => ({AuthorizationJWT: `Bearer ${jwt}`});

export const transformFilters = (filters: Filters): Record<string, string | number | boolean> => {
  const newFilters = Object.keys(filters).reduce((acc: Filters | {[key: string]: undefined}, key) => {
    const value = filters[key];
    if (key === FILTER_FACET) {
      acc[FILTER_FACET] = Array.isArray(value) ? value.join(',') : value;
    } else {
      acc[key] = isArray(value) ? (isEmpty(value) ? undefined : value.join('|')) : value;
    }

    return acc;
  }, {});

  return ObjectHelper.cleanObject(newFilters) as Record<string, string | number | boolean>;
};
